var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke fill",
    d: "M32.586 10.771A7.275 7.275 0 0025.315 3.5H10.772A7.275 7.275 0 003.5 10.77v14.561a7.275 7.275 0 007.272 7.272h14.543a7.275 7.275 0 007.27-7.272v-14.56z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    d: "M32.586 49.667a7.275 7.275 0 00-7.271-7.272H10.772A7.275 7.275 0 003.5 49.667v14.561a7.275 7.275 0 007.272 7.271h14.543a7.275 7.275 0 007.27-7.27V49.666z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    d: "M71.502 38.866V10.835c0-4.049-3.285-7.335-7.331-7.335H49.51c-4.046 0-7.331 3.286-7.331 7.335v53.33c0 4.048 3.285 7.335 7.33 7.335h14.662c4.046 0 7.33-3.287 7.33-7.335v-7.217"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.159871f03fba28a1d83bfdb1d24689e7.svg";
export { ForwardRef as ReactComponent };